import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TipoArredondamentoEnum } from '@shared/enums/formula/tipo-arredondamento.enum';

/** Solicita a estratégia quando uma constante decimal fracionária passa a ser inteira. */
@Component({
    selector: 'app-constante-numerica-conversao-dialog',
    standalone: true,
    imports: [MatButtonModule, MatDialogModule],
    templateUrl: './constante-numerica-conversao-dialog.component.html',
    styleUrl: './constante-numerica-conversao-dialog.component.css',
})
export class ConstanteNumericaConversaoDialogComponent {
    public readonly TipoArredondamentoEnum = TipoArredondamentoEnum;

    constructor(public dialogRef: MatDialogRef<ConstanteNumericaConversaoDialogComponent, TipoArredondamentoEnum | undefined>) {}
}
